<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters, mapState } from "vuex";
import datetime from "@/mixins/datetime";
import moment from "moment";

export default {
  name: "CalendarReservationPreview",
  props: ["events", "start_date", "end_date", "className", "duration"],
  mixins: [datetime],
  components: {
    FullCalendar,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
  },
  data() {
    return {
      isLoading: true,
      dataSelected: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGrid",
        views: {
          dayGrid: {
            type: 'dayGrid',
            duration: { months: 1 },
          },
        },
        weekends: true,
        headerToolbar: false,
        contentHeight: "auto",
        height: "auto",
        locale: "ja",
        showNonCurrentDates: true,
        events: (info, successCallback, failureCallback) => {
					this.getData({
						start_date: info.startStr,
						end_date: info.endStr
					}, successCallback)
					this.handleLoadDataAlreadyChecked();
        },
        eventClick: info => {
          this.handleClickEvent(info);
        },
        eventDidMount: info => {
          this.handleEventDidMounted(info);
        },

        //initialDate: this.checkInitialDateInMonth() ?? this.getInitialDay(),
        initialDate: this.getInitialDay(),
        datesSet: date_info => {
          this.$nextTick(() => {
            this.deleteRowEndEmpty();
            this.addColumnHour();
            this.setHeight();
          });
        },
      },
      loadingFirstTime: true,
      numberRow: 0
    };
  },
  methods: {
		getCalendarApi() {
			return this.$refs.fullcalendar.getApi();
		},
    getInitialDay() {
      return this.addOrSubtractTimeFromDate(parseInt(this.duration), 'months', 'add', this.getToday(), 'YYYY-MM-DD');
    },
    setHeight() {
      const hour = document.querySelectorAll('.fc .fc-daygrid-body .column-am-pm td div')
      const wrapHourLevel1 =  document.querySelectorAll('.fc .fc-daygrid-body .column-am-pm td')
      const wrapHourLevel2 =  document.querySelectorAll('.fc .fc-daygrid-body .column-am-pm tr')
      const areaDay =  document.querySelectorAll('.fc-daygrid-day-events')

      for (const element of areaDay) {
        element.classList.add('height-50');
      }

			hour.forEach((element, index) => {
				if (element.textContent == '') {
					element.classList.add('height-29');
				} else if (element.textContent == 'PM') {
					element.classList.add('height-21');
				} else {
					element.classList.add('height-19');
				}

				if (index + 1 == hour.length) {
					element.style.borderBottom = 'none'
				}
			})
      
      for (const element of wrapHourLevel1) {
        element.classList.add('height-52');
      }

      for (const element of wrapHourLevel2) {
        element.classList.add('height-75');
      }
    },
    deleteRowEndEmpty() {
      let blockDay = document.querySelectorAll("." + this.className + " .fc-scrollgrid-sync-table tr:last-child td:first-child .fc-daygrid-day-frame > div")
      const rowNotDay = document.querySelector("." + this.className + " .fc-scrollgrid-sync-table tr:last-child");

      this.numberRow = document.querySelectorAll("." + this.className + " .fc-scrollgrid-sync-table tr").length;
      if (blockDay.length == 2) {
        this.numberRow = this.numberRow--;
        rowNotDay.remove()
      }
    },
    async getData(params, successCallback) {
      try {
        let start_date = this.start_date ? this.start_date : this.formatDate(params.start_date);
        let end_date = this.end_date ? this.end_date : this.formatDate(params.end_date);
        //check if plus 13 month from now then end_date only select last date of that limited month
        if (this.limitedDate) {
          const endDate = new Date(end_date);
          if (endDate.getFullYear() == this.limitedDate.year() && endDate.getMonth() >= this.limitedDate.month() ) {
            end_date = moment(this.limitedDate.format('YYYY-MM-DD')).endOf('month').format('YYYY-MM-DD')
          }
        }

				if (!params.start_date || !params.end_date) {
					return;
				}

        const url = apiEndpoints.setting_calendar_getAll();
        this.isLoading = true;
        const { status, data } = await this.$http.getWithLoading(url, params);
        this.isLoading = false;

        if (status) {
          let events = [];
          events = this.handleMappingDataFromApi(data.result, start_date, end_date);
          events = this.handleLoadReservationType(events);
          successCallback(events)

          return;
        } else {
          return;
        }
      } catch (e) {
      }
    },
    generateDatesToValidate(start, end) {
      // generate list date from start to end
      // each day has 2 objects AM and PM
      // object date include work_reservation_date as date, zz_day_of_time_zone_id 1 if AM, 2 if PM
      // if start > end, return empty
      if (start > end) {
        return [];
      }
      let listDates = [];
      let start_date = moment(start);
      let end_date = moment(end);
      while (start_date <= end_date) {
        let date = start_date.format("YYYY-MM-DD");
        listDates.push({ work_reservation_date: date, zz_day_of_time_zone_id: '1', zz_reservation_type_id: '' });
        listDates.push({ work_reservation_date: date, zz_day_of_time_zone_id: '2', zz_reservation_type_id: '' });
        start_date = start_date.add(1, "days");
      }
      return listDates;
    },
    mappingValidatedDates(dates) {
      let events = [];
      if (!dates.length) return [];
      let present = moment();

      dates.forEach(date => {
        let dateSchedule = moment(date.work_reservation_date);
        if (present.year() == dateSchedule.year() && (present.format('M') - dateSchedule.format('M')) > 1) {
          return
        }
        let title = this.$constant.CALENDAR_RESERVATION_TYPES[date['zz_reservation_type_id']] ?? "";
        if (dateSchedule.isBefore(present, 'day')) {
          title = '';
        }
        events.push({
          title: title,
          start: date['work_reservation_date'] + this.$constant.CALENDAR_DAY_OF_TIME_ZONE[this.$constant.ZZ_DAY_OF_TIME_ZONE_LABEL[date['zz_day_of_time_zone_id']]],
          work_reservation_date: date['work_reservation_date'],
          zz_day_of_time_zone_id: date['zz_day_of_time_zone_id'],
          zz_reservation_type_id: date['zz_reservation_type_id']
        });
      })

      return events;
    },
    handleMappingDataFromApi(data, start_date, end_date) {
      var events_data = [];
      let listDates = this.listDaysBetweenDates(start_date, end_date);
      //loop through everyday of month to fill events
      listDates.forEach(date => {
        let isSatisfy = !data.some(item => item.date == date);
        if (isSatisfy) {
          this.options_tables.zz_day_of_time_zones.forEach(timezone => {
            let title = "";
            let zz_reservation_type_id = "";

            events_data.push({
              title: title,
              start:
                date +
                this.$constant.CALENDAR_DAY_OF_TIME_ZONE[
                  timezone.day_of_time_zone
                ],
              work_reservation_date: date,
              zz_day_of_time_zone_id: timezone.id,
              zz_reservation_type_id: zz_reservation_type_id
            });
          });
        }
      });
      data.forEach(data => {
        //loop 2 timezone AM and PM
        this.options_tables.zz_day_of_time_zones.forEach(timezone => {
          //get reservation_type_id from data api
          let reservation_type_id =
            timezone.day_of_time_zone === "AM"
              ? data.zz_reservation_accept_type_am
              : data.zz_reservation_accept_type_pm;
          if (reservation_type_id == 0) {
            reservation_type_id = null;
          } else {
            reservation_type_id = this.$constant
              .RESERVATION_ACCEPT_TO_RESERVATION_TYPE[reservation_type_id];
          }
          let zz_reservation_type_id = reservation_type_id ?? "";
          //if dont have reservation_type_id then mapping from events prop
          if (!zz_reservation_type_id && this.events) {
            let event = this.events.find(
              obj =>
                obj.work_reservation_date === data.date &&
                parseInt(obj.zz_day_of_time_zone_id) === parseInt(timezone.id)
            );
            if (event && event.zz_reservation_type_id) {
              zz_reservation_type_id = event.zz_reservation_type_id;
            }
          }
          let title = zz_reservation_type_id
            ? this.$constant.CALENDAR_RESERVATION_TYPES[zz_reservation_type_id]
            : "";

            events_data.push({
              title: title,
              start:
                data.date +
                this.$constant.CALENDAR_DAY_OF_TIME_ZONE[
                  timezone.day_of_time_zone
                ],
              work_reservation_date: data.date,
              zz_day_of_time_zone_id: timezone.id,
              zz_reservation_type_id: zz_reservation_type_id
            });
        });
      });

      return events_data;
    },
    handleLoadDataAlreadyChecked() {
      if (this.loadingFirstTime) {
        this.dataSelected = [];
        let eventsProp = this.events;
        eventsProp.forEach(item => {
          let eventSelected = (({
            work_reservation_id,
            zz_reservation_frequency_type_id,
            ...e
          }) => e)(item);

          this.dataSelected.push(eventSelected);
        });
        this.$emit("onSelectedData", this.dataSelected);
        this.loadingFirstTime = false;
      }
    },
    handleLoadReservationType(events_prop) {
      this.events?.forEach(item => {
        let indexEvent = events_prop.findIndex(
          event =>
            item.work_reservation_date == event.work_reservation_date &&
            item.zz_day_of_time_zone_id == event.zz_day_of_time_zone_id
        );
        if (
          indexEvent >= 0 &&
          item.zz_reservation_type_id &&
          !events_prop[indexEvent].title
        ) {
          events_prop[
            indexEvent
          ].title = this.$constant.CALENDAR_RESERVATION_TYPES[
            item.zz_reservation_type_id
          ];
          events_prop[indexEvent].zz_reservation_type_id =
            item.zz_reservation_type_id;
        }
      });

      return events_prop;
    },
    handleClickEvent(info) {
      const dateParsed = this.$moment(info.event.extendedProps.work_reservation_date);
      const today = this.$moment();
      const tomorrow = this.$moment().add(1, 'days');
      if (dateParsed.isSame(today, 'day') || dateParsed.isSame(tomorrow, 'day')) {
        return;
      }

			let bg = info.el.style.backgroundColor;
			if (
				bg === "orange" &&
				this.checkIfThisEventSelected(info) !== undefined
			) {
				this.dataSelected = this.dataSelected.filter(item => {
					if (
						item.work_reservation_date ===
							info.event.extendedProps.work_reservation_date &&
						item.zz_day_of_time_zone_id ===
							info.event.extendedProps.zz_day_of_time_zone_id
					) {
						return false;
					}
					return true;
				});
				info.el.style.backgroundColor = "unset";
			} else {
				this.dataSelected.push(info.event.extendedProps);
				info.el.style.backgroundColor = "orange";
			}
			this.$emit("onSelectedData", this.dataSelected);
    },
    handleEventDidMounted(info) {
      if (this.checkIfThisEventSelected(info) !== undefined) {
        info.el.style.backgroundColor = "orange";
      }
    },
    checkIfThisEventSelected(info) {
      let isSelected = this.dataSelected.find(
        item =>
          item.work_reservation_date ===
            info.event.extendedProps.work_reservation_date &&
          parseInt(item.zz_day_of_time_zone_id) ===
            parseInt(info.event.extendedProps.zz_day_of_time_zone_id)
      );

      return isSelected;
    },
    checkInitialDateInMonth() {
      var initialDate;
      let today = this.getInitialDay();
      let lastDayOfMonth = this.getStartOrEndDateThisMonth("end");

      if (today === lastDayOfMonth) {
        let subtractDate = this.addOrSubtractTimeFromDate(
          4,
          "days",
          "subtract"
        );
        initialDate = this.addOrSubtractTimeFromDate(
          1,
          "month",
          "add",
          subtractDate
        );
      }

      return initialDate;
    },
    addColumnHour() {
      //remove if exit
      const bodyExits = document.querySelectorAll("." + this.className + " .column-am-pm");
      if (bodyExits) {
        for (const element of bodyExits) {
          element.remove();
        }
      }

      const headerExits = document.querySelectorAll("." + this.className + " .header-th");
      if (headerExits.length != 0) {
        for (const element of headerExits) {
          element.remove();
        }
      }

      //add new
      const headingsCase1 = document.querySelectorAll("." + this.className + " .fc-col-header tbody tr");
      const headingsCase2 = document.querySelectorAll("." + this.className + " .fc-col-header thead tr");
      const body = document.querySelectorAll("." + this.className + " .fc-daygrid-body");
      for (const element of headingsCase1) {
        element.insertAdjacentHTML("afterbegin", '<th class="header-th"></th>');
      }
      for (const element of headingsCase2) {
        element.insertAdjacentHTML("afterbegin", '<th class="header-th"></th>');
      }
      let addRowHour = '';
      for (let i = 0; i < this.numberRow; i++) {
        addRowHour += '<tr><td><div></div><div>AM</div><div>PM</div></td></tr>';
      }
      for (const element of body) {
        let hour = '<table class="column-am-pm">' + addRowHour + "</table>";
        element.insertAdjacentHTML("afterbegin", hour);
      }
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    ...mapState("options", ["system_codes"]),
    limitedDate() {
      return undefined;
    }
  }
};
</script>
<template>
	<b-overlay
		:show="isLoading"
		rounded
		opacity="0.6"
		spinner-small
		spinner-variant="primary"
		class="d-inline-block"
	>
		<FullCalendar ref="fullcalendar" :options="calendarOptions">
			<template v-slot:eventContent="arg">
				<span class="fw-600">{{ arg.event.title }}</span>
			</template>
		</FullCalendar>
	</b-overlay>
</template>
<style lang="scss">
.setting_admin_calendar_display_month .fc {
  font-size: 14px;

  .fc-header-toolbar {
    .fc-toolbar-chunk {
      display: flex;
      align-items: center;
    }
  }

  .fc-daygrid-day {
    .fc-daygrid-day-top {
      display: flex;
      justify-content: center;
      border-bottom: 1px solid var(--fc-border-color, #ddd);
    }
  }

  .fc-daygrid-day.fc-day-today {
    background: none;
  }

  .fc-event.fc-daygrid-event {
    background-color: unset;
  }

  .fc-daygrid-day-events {
    margin-top: unset;
    margin-bottom: unset;
    height: 130px;

    .fc-daygrid-event-harness:first-child .fc-daygrid-event {
      border-bottom: 1px solid var(--fc-border-color, #ddd);
    }
  }

  .fc-daygrid-event-harness {
    height: 50%;

    .fc-daygrid-event {
      display: flex;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      color: black !important;
      height: 100%;
      margin-top: 0px;
      margin-bottom: 0px;
      border-radius: unset;
    }

    .fc-daygrid-event:hover {
      background-color: rgba(251, 192, 147);
    }

    .fc-daygrid-event.fc-event-start {
      margin-left: 0px;
    }

    .fc-daygrid-event.fc-event-end {
      margin-right: 0px;
    }
  }

  .fc-daygrid-dot-event:hover {
    cursor: pointer;
  }

  .fc-day-sun {
    background-color: rgba(255, 120, 71, 0.1);
  }

  .fc-day-sat {
    background-color: rgba(137, 196, 244, 0.1);
  }

  .fc-daygrid-body {
    display: inline-flex;

    .column-am-pm {
      width: 36px;

      tr {
        height: 161px;
      }

      td {
        width: 36px;
        height: 132px;
        border: none;
        display: block;
        text-align: center;

        div {
          width: 100%;
          display: grid;
          align-items: center;
          height: 65px;
          border: 1px solid #a9a9a9;
        }

        div:first-child {
          height: 29px;
          border: none;
          border-right: 1px solid #dfdddd;
        }

        div:nth-child(2) {
          border-bottom: none;
        }

        div:nth-child(3) {
          height: 67px;
        }
      }
    }
  }

  .fc-col-header tbody tr th:first-child, .fc-col-header thead tr th:first-child {
    width: 35px;
  }

  .fc-scrollgrid {
    border-left: none;
    border-top: none;
  }

  .fc-col-header tbody , .fc-col-header thead tr {
    th div {
      border-top: 1px solid var(--fc-border-color, #ddd);
    }

    th:first-child {
      border-bottom: 0px;
    }
  }

  .fc-daygrid-day-events {
    margin-bottom: 0px !important;
  }

  .fc-daygrid-day-number, .fc-col-header-cell-cushion {
    color: #495057;
  }

  .fc-daygrid-event span {
    color: #045e94;
  }

  .height-25 {
    height: 19px!important;
  }

  .height-52 {
    height: 40px!important;
  }
  .height-75 {
    height: 63px!important;
  }
  .height-50 {
    height: 38px!important;
  }
}
.reserve_info_calendar_current_month .fc,
.reserve_info_calendar_next_month .fc {
  .fc-daygrid-body {
    display: inline-flex;

    .column-am-pm {
      width: 36px;

      tr {
        height: 161px;
      }

      td {
        width: 36px;
        height: 132px;
        border: none;
        display: block;
        text-align: center;

        div {
          width: 100%;
          display: grid;
          align-items: center;
          height: 65px;
          border: 1px solid #a9a9a9;
        }

        div:first-child {
          height: 29px;
          border: none;
          border-right: 1px solid #dfdddd;
        }

        div:nth-child(2) {
          border-bottom: none;
        }

        div:nth-child(3) {
          height: 67px;
        }
      }
    }
  }

  .height-19 {
    height: 19px!important;
  }
  .height-21 {
    height: 21px!important;
  }
  .height-29 {
    height: 29px!important;
  }

  .height-52 {
    height: 40px!important;
  }
  .height-75 {
    height: 69px!important;
  }
  .height-50 {
    height: 38px!important;
  }
}
</style>
